// eslint-disable-next-line
import { h, Component } from 'preact';
import IconClose from './../IconClose';
import IconError from './../IconError';

import styles from './index.scss';

class Header extends Component {
    renderWarnMessage() {
        const { numberOfItems, pr_of, numberOfUnavailableItems, unavailable } = this.props;

        if (numberOfUnavailableItems > 0) {
            return (
                <div className={styles.headerWarnMessage}>
                    <IconError />&nbsp;
                    <span
                        className={styles.headerWarnMessage__text}
                    >{`${numberOfUnavailableItems} ${pr_of} ${numberOfItems} ${unavailable}`}</span>
                </div>
            );
        }

        return null;
    }

    onClick = ev => {
        ev.preventDefault();
        ev.stopPropagation();

        return this.props.onClose();
    };

    render() {
        const { extraClass = '', miniCart_title } = this.props;

        return (
            <header className={`${styles.header} ${extraClass}`}>
                <div className={styles.headerInner}>
                    <div className={styles.headerTitle}>
                        <div className={styles.message} dangerouslySetInnerHTML={{ __html: miniCart_title }} />
                        <div className={styles.close} onClick={this.onClick}>
                            <IconClose width={11} height={9} />
                        </div>
                    </div>
                    {this.renderWarnMessage()}
                </div>
            </header>
        );
    }
}

export default Header;
